import {
  Row,
  Col,
  Form,
  Button,
  Tooltip,
  InputGroup,
  OverlayTrigger
} from "react-bootstrap";
// import Select from "react-select";
import _debounce from "lodash/debounce";
import {
  faCheck,
  faPencil,
  faWarning
} from "@fortawesome/free-solid-svg-icons";
import { useParams } from "react-router-dom";
import React, { useState, useMemo, useEffect } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  showError,
  showSuccess,
  showWarning
} from "../../services/toast-service";
import {
  saveCustomerWebDomain,
  getCustomerWebsiteInfo
} from "../../services/api-declaration";
import { useDialog } from "../../hooks/useDialog";
import LinkPreviewComponent from "../link-preview";
import { Legend, ValiditySpinner } from "../common-styling";
import { DNS_RECORD_TYPES, WEBSITE_BASE_TAB_ROUTE } from "../strings";
import { generateCustomerSiteUrl } from "../../services/common-service";
import ValidationMessage from "../validation-message/validation-message";
import { useTranslation } from "react-i18next";

const WebsiteDomainSection = ({
  setIsDomainValid,
  isDomainValid,
  btnRef,
  // setShouldUpdateNonActive,
  inDialog = false,
  noHeading = false,
  customerId = null,
  selectedCustomerId = null,
  dnsResult = null,
  dnsLoading,
  showCheckDNS,
  setShowCheckDNS,
  getDNS,
  isEditable,
  setIsEditable,
  tabRoute
}) => {
  const { t } = useTranslation();
  const {
    formState: { errors },
    control,
    watch,
    trigger
    // register
  } = useFormContext();
  const params = useParams();
  const { showConfirmationDialogBox } = useDialog();
  const [isDomainChanged, setIsDomainChanged] = useState(false);
  const [isNonActive, setIsNonActive] = useState(false);
  const [noActiveTemplate, setNonActiveTemplate] = useState({});
  const [isShowSaveDomain, setIsShowSaveDomain] = useState(false);
  const [isSavingDomain, setIsSavingDomain] = useState(false);
  const isNestedWebsiteTab = tabRoute !== WEBSITE_BASE_TAB_ROUTE;
  const domain = watch("domain");

  const toggleConfirmation = () =>
    showConfirmationDialogBox({
      title: "Warning!",
      dialogType: "warning",
      responseAction: dialogResponseAction,
      dialogMessage: dialogMessage()
    });

  const handleDomainChange = (fieldVal) => {
    if (fieldVal) {
      setIsDomainChanged(true);
      setIsShowSaveDomain(false);
    }
  };
  const dialogResponseAction = (action) => {
    if (action && noActiveTemplate?.templateId) {
      setIsDomainValid(true);
      setIsNonActive(false);
    }
  };
  const dialogMessage = () => (
    <div>
      Do you want to use this domain and subdomain anyway?
      <div>
        Because it will remove domain and subdomain from Template Of Customer{" "}
        <OverlayTrigger overlay={<Tooltip>{t("common.archive")}</Tooltip>}>
          <b>{noActiveTemplate?.customerId}</b>
        </OverlayTrigger>
      </div>
    </div>
  );
  const handleDebounceCb = useMemo(
    () =>
      _debounce(async (selectedCustomerId) => {
        const domainValue = watch("domain");
        try {
          if (domainValue) {
            const response = await getCustomerWebsiteInfo({
              domain: domainValue
            });
            if (
              response.data.data &&
              response.data.data.customerId !== selectedCustomerId &&
              ((customerId && response.data.data.customerId === customerId) ||
                response.data.data.customerId !== params.id)
            ) {
              let toastMsg = "";
              if (response.data.data.active === false) {
                toastMsg = t("websiteDomainNonActiveMsg1");
                setNonActiveTemplate({
                  templateId: response.data.data._id,
                  customerId: response.data.data.customerId
                });
              } else {
                toastMsg = t("domainArchivedMsg2");
              }
              setIsNonActive(response.data.data.active);
              setIsDomainValid(false);
              showWarning(toastMsg);
            } else {
              setIsDomainValid(true);
            }
          }
        } catch (err) {
          console.log("ERR ", err);
          showError(
            err.response.data.message || t("toastMessage.funnelByDomain")
          );
        } finally {
          setIsDomainChanged(false);
        }
      }, 2000),
    // eslint-disable-next-line
    [setIsDomainValid, params.id, btnRef, watch, selectedCustomerId]
  );

  useEffect(() => {
    // btnRef.current.disabled = true;
    setIsDomainChanged(true);
    handleDebounceCb(selectedCustomerId);
  }, [selectedCustomerId, handleDebounceCb, btnRef]);

  const manageDNSCheck = async () => {
    const isValid = await trigger("domain");
    await getDNS(watch("domain"), isValid);
    isValid && setIsShowSaveDomain(true);
  };

  const handleSaveDomain = async () => {
    try {
      setIsSavingDomain(true);
      const response = await saveCustomerWebDomain(params.id, {
        domain: watch("domain"),
        active: true
      });
      setIsShowSaveDomain(false);
      showSuccess(response?.data?.message);
    } catch (err) {
      console.log(err?.response?.data?.message);
    } finally {
      setIsSavingDomain(false);
    }
  };

  const domainInputField = (
    <Controller
      control={control}
      name="domain"
      render={({ field }) => (
        <Form.Control
          type="text"
          {...field}
          placeholder="domain"
          onChange={(e) => {
            field.onChange(e);
            setIsDomainValid(true);
            setShowCheckDNS(true);
            handleDomainChange(e.target.value);
            handleDebounceCb(selectedCustomerId);
          }}
          disabled={!isEditable || isNestedWebsiteTab}
          className={errors.domain && "border-danger"}
        />
      )}
    />
  );

  return (
    <div className="py-0 px-0">
      {!noHeading && (
        <Legend>
          <h4 className="mb-3 fw-bold">Domain</h4>
        </Legend>
      )}
      <div className="px-0">
        <Row>
          <Col xs={12} md={inDialog ? 12 : 4}>
            <div>
              {noHeading && <Form.Label> Domain</Form.Label>}
              <InputGroup className="d-flex align-items-center">
                {isNestedWebsiteTab ? (
                  domainInputField
                ) : (
                  <>
                    {domainInputField}
                    {!isEditable && (
                      <Button
                        variant="outline-secondary"
                        size="md"
                        onClick={() => setIsEditable(true)}
                      >
                        <FontAwesomeIcon icon={faPencil} />
                      </Button>
                    )}

                    {showCheckDNS && !isDomainChanged && (
                      <Button
                        variant="primary"
                        size="md"
                        onClick={manageDNSCheck}
                        disabled={!isDomainValid}
                      >
                        Validate
                      </Button>
                    )}
                    {(isDomainChanged || dnsLoading) && (
                      <ValiditySpinner
                        animation="border"
                        variant="secondary"
                        className="ms-2 rounded-circle"
                      />
                    )}

                    {!dnsLoading && !isDomainChanged && !showCheckDNS && (
                      <>
                        {dnsResult === DNS_RECORD_TYPES.NON_ACTIVE && (
                          <OverlayTrigger
                            overlay={
                              <Tooltip>
                                DNS record not matched with hosting IP Address
                              </Tooltip>
                            }
                          >
                            <Button variant="warning" size="md">
                              <FontAwesomeIcon icon={faWarning} />
                            </Button>
                          </OverlayTrigger>
                        )}

                        {dnsResult === DNS_RECORD_TYPES.NOT_FOUND && (
                          <OverlayTrigger
                            overlay={<Tooltip>Domain Not Found</Tooltip>}
                          >
                            <Button variant="danger" size="md">
                              <FontAwesomeIcon icon={faWarning} />
                            </Button>
                          </OverlayTrigger>
                        )}

                        {dnsResult === DNS_RECORD_TYPES.ACTIVE && (
                          <OverlayTrigger
                            overlay={
                              <Tooltip>
                                DNS record matched with hosting IP Address
                              </Tooltip>
                            }
                          >
                            <Button variant="success" size="md">
                              <FontAwesomeIcon icon={faCheck} />
                            </Button>
                          </OverlayTrigger>
                        )}
                      </>
                    )}
                  </>
                )}
              </InputGroup>

              {errors.domain && (
                <ValidationMessage error={errors.domain.message} />
              )}

              {!isDomainValid && !isNestedWebsiteTab && (
                <div className="mt-2 small text-danger fw-bold">
                  {!isNonActive && !inDialog ? (
                    <div className="d-flex justify-content-between">
                      {t("websiteDomainNonActiveMsg1")}
                      <Button onClick={toggleConfirmation}>
                        {t("useAnyway")}
                      </Button>
                    </div>
                  ) : (
                    t("notAllowedDomainMsg")
                  )}
                </div>
              )}
              <LinkPreviewComponent
                link={generateCustomerSiteUrl({ domain, tabRoute })}
                linkText={`https://${domain}${tabRoute === WEBSITE_BASE_TAB_ROUTE ? "" : tabRoute}`}
                show={watch("domain")}
                showCopyButton={true}
              />
            </div>
          </Col>
          {isShowSaveDomain && !isNestedWebsiteTab && (
            <Col xs={12} md={2}>
              <Button
                variant="primary"
                className="w-full"
                disabled={isSavingDomain}
                onClick={handleSaveDomain}
              >
                Save
              </Button>
            </Col>
          )}
        </Row>
      </div>
    </div>
  );
};

export default WebsiteDomainSection;
